import { StyleSheet } from "react-native";

export default StyleSheet.create({
  container: {
    color: "#fff",
    borderRadius: 25,
  },
});
